import { render, staticRenderFns } from "./SBNumberMultiselect.vue?vue&type=template&id=1091fdb6&scoped=true&"
import script from "./SBNumberMultiselect.vue?vue&type=script&lang=js&"
export * from "./SBNumberMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./SBNumberMultiselect.vue?vue&type=style&index=0&id=1091fdb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1091fdb6",
  null
  
)

export default component.exports